<template>
  <div class="p-1">
    <b-form @submit="onSubmit" @reset="onReset">
      <b-row class="">
        <!-- previous password -->
        <b-col sm="12" >
          <b-input-group size="">
            <b-form-input id="prevPass" type="password" :state="prevPassMatched"
            v-model="prevPass" placeholder="Enter current password correctly" required
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="toggle" >show</b-button>
            </b-input-group-append>
          </b-input-group> 
        </b-col>
        <!-- new password -->
        <b-col sm="12" class="pt-2">
          <b-input-group size="">
            <b-form-input id="newPass" type="password" :disabled="!isUser" 
            :state="newPassLength" required
            v-model="newPass" placeholder="Enter new password, minimum 5 charecter"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="toggle">show </b-button>
            </b-input-group-append>
          </b-input-group> 
        </b-col>
        <!-- confirm new pass -->
        <b-col sm="12" class="pt-2">
          <b-input-group size="">
            <b-form-input id="confirmPass" type="password" :disabled="!isUser"
            :state="confirmed" required
            v-model="confirmNewPass" placeholder="confirm new password"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="toggle">show </b-button>
            </b-input-group-append>
          </b-input-group> 
        </b-col>
      </b-row>
      <!-- buttons -->
      <b-row align-h="around" class="pt-2">
        <b-col cols='0'>
          <b-button size="sm" type="submit" variant="danger">Change</b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications'
import axios from 'axios'

export default {  
  props: ['modalRef'],
  data() {
    return {
      english:true,
      oldPass:'',
      prevPass:null,
      isUser:false,
      newPass:"",
      confirmNewPass:null,
      show:true
    }
  },
  computed: {
    prevPassMatched(){
      if(this.prevPass){
        this.prevMatched(this.prevPass)
        .then(()=>{
          if(this.isUser)return true;
          else return false;
        });
      }
      // if(this.prevPass === this.oldPass){
      //   this.isUser=true;
      //   return true;
      // }
      // this.isUser=false;
      // return false;
    },
    newPassLength() {
      return this.newPass.length > 4 ? true:false; 
    },
    confirmed(){
      return this.newPass === this.confirmNewPass ? true:false;
    }
  },
  created(){
    // this.getOld();
  },
  methods:{
    toggle(evt){
      // console.log(evt);
      if( evt.target.innerText=='show'){
        evt.target.innerText="hide";
        //selects the input field where the btn event came from
        evt.path[2].childNodes[2].type="text"; 
      }
      else{
        evt.target.innerText="show";
        evt.path[2].childNodes[2].type="password";
      }
    },
    onSubmit(evt){
      evt.preventDefault();
      if( this.newPass.length > 4){
        if( this.newPass === this.confirmNewPass ){
          this.change();
          //hide the modal
          this.modalRef.hide();
        }
        else{
          this.showErrorMsg({title:"new password and confirm password didn't matched!", timeout:3000 });
        }
      }
      else{
          this.showErrorMsg({title:"Password has to be minimum 5 charecters", timeout:3000 });
      }
    },
    change(){
      //  return axios.get( `http://192.168.100.107:8080/pilgrimDB/change.php`,{
      // return axios.get(`pilgrimDB/change.php`,{
      // params:{ change:this.newPass},  withCredentials: true
      // })
      // .then(response => {
      //   if(response.data==1){
          this.showSuccessMsg({title:"Password changed (Demo)", timeout:3000 });
      //   }
      //   else{
      //     this.showErrorMsg({title:"something went wrong", timeout:3000 });
      //   }
      // })
      // .catch(error => {
      //   if(!error.response){
      //     this.showErrorMsg({title:"Network Error!!"})
      //   }
      //   else{
      //     this.showErrorMsg({title:error.response})
      //   }
      //   console.log(error);
      // });
    },
    getOld(){
      //  return axios.get( `http://192.168.100.107:8080/pilgrimDB/change.php`,{
      return axios.get(`pilgrimDB/change.php`,{
      params:{ who:'admin'},  withCredentials: true
      })
      .then(response => {
        this.oldPass= response.data[0].password;
        // console.log(response);
      })
      .catch(error => {
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    prevMatched(secret){
      return axios.get(`pilgrimDB/change.php`,{
      params:{ who:'admin', password: secret},  withCredentials: true
      })
      .then(response => {
        if(response.data ==1){
          this.isUser=true;
        }
        else{
          this.isUser=false;
        }
      })
      .catch(error => {
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    onReset(evt){
      evt.preventDefault();
      this.showWarnMsg({title:"Enter new password again!",timeout:3000})
      this.newPass="";
      this.confirmNewPass=null;
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000

    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000

    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000
    }
  }
}
</script>

<style>
#prevPass, #newPass, #confirmPass{
  color: black;
}
</style>

